import { api } from './api'

function assertSuccess(body: { success?: boolean; message?: string; data?: unknown }) {
  if (!body?.success) {
    throw new Error(body?.message || 'Request failed')
  }
  return body.data
}

function apiError(err: unknown, fallback: string) {
  const e = err as { response?: { data?: { message?: string } }; message?: string }
  return new Error(e?.response?.data?.message || e?.message || fallback)
}

export type PlatformOpsSettings = {
  withdrawalsRequireApproval: boolean
}

export async function getPlatformOpsSettings(): Promise<PlatformOpsSettings> {
  try {
    const { data } = await api.get('/admin/platform/ops-settings')
    return assertSuccess(data) as PlatformOpsSettings
  } catch (e) {
    throw apiError(e, 'Failed to load ops settings')
  }
}

export async function patchPlatformOpsSettings(
  body: Partial<PlatformOpsSettings>,
): Promise<PlatformOpsSettings> {
  try {
    const { data } = await api.patch('/admin/platform/ops-settings', body)
    return assertSuccess(data) as PlatformOpsSettings
  } catch (e) {
    throw apiError(e, 'Failed to update ops settings')
  }
}
